// src/utils/utils_utcToLocalInText.ts
// Les commentaires des logs créateur contiennent des dates écrites PAR LE SERVEUR, au
// format « 01/10/2026 à 07:47:00 » et en UTC (cf. BroadcastingChannelActivationService /
// DesactivationService). On les réécrit à l'affichage dans le fuseau du navigateur.
// Les anciennes lignes (même format, même UTC) sont converties de la même façon.

const UTC_DATE_IN_TEXT = /(\d{2})\/(\d{2})\/(\d{4}) à (\d{2}):(\d{2}):(\d{2})/g;

const pad = (n: number): string => String(n).padStart(2, '0');

export function utcTimesToLocalInText(text: string): string {
  if (!text) return text;
  return text.replace(UTC_DATE_IN_TEXT, (match, dd, mm, yyyy, hh, mi, ss) => {
    const date = new Date(Date.UTC(+yyyy, +mm - 1, +dd, +hh, +mi, +ss));
    if (Number.isNaN(date.getTime())) return match;
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} à `
         + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  });
}
